import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

export interface CertificateFormData {
  name: string;
  type: 'Front' | 'Back';
  dev?: string;
  preprod?: string;
  prod?: string;
}

@Component({
  selector: 'app-certificate-form',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './certificate-form.component.html',
  styleUrls: ['./certificate-form.component.scss'],
})
export class CertificateFormComponent implements AfterViewInit {
  @Input() isSubmitting = false;
  @Output() submitCertificate = new EventEmitter<CertificateFormData>();
  @Output() cancel = new EventEmitter<void>();
  @ViewChild('nameInput') nameInput!: ElementRef<HTMLInputElement>;

  formData: CertificateFormData = {
    name: '',
    type: 'Front',
    dev: '',
    preprod: '',
    prod: '',
  };

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.nameInput?.nativeElement.focus();
    }, 100);
  }

  onSubmit(): void {
    if (this.isValid && !this.isSubmitting) {
      // Clean up empty date fields
      const dataToSubmit: CertificateFormData = {
        name: this.formData.name,
        type: this.formData.type,
      };

      if (this.formData.dev) dataToSubmit.dev = this.formData.dev;
      if (this.formData.preprod) dataToSubmit.preprod = this.formData.preprod;
      if (this.formData.prod) dataToSubmit.prod = this.formData.prod;

      this.submitCertificate.emit(dataToSubmit);
    }
  }

  onCancel(): void {
    this.formData = {
      name: '',
      type: 'Front',
      dev: '',
      preprod: '',
      prod: '',
    };
    this.cancel.emit();
  }

  get isValid(): boolean {
    return (
      this.formData.name.trim().length > 0 &&
      (!!this.formData.dev || !!this.formData.preprod || !!this.formData.prod)
    );
  }
}
